import { render, staticRenderFns } from "./ListUsersActions.vue?vue&type=template&id=22a2637d&"
import script from "./ListUsersActions.vue?vue&type=script&lang=ts&"
export * from "./ListUsersActions.vue?vue&type=script&lang=ts&"
import style0 from "./ListUsersActions.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports